import { useNavigate, useParams } from 'react-router-dom';
import { FormFieldsData } from 'framework/form';
import { SideDrawer } from 'framework/ui/mui-builder';

import useClientPortalService from '../useClientPortalService';
import ApproveClientUsersDrawerContent from './ApproveClientUsersDrawerContent';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  useNewProjectUrl,
  useProjectSecurityContext,
} from 'domain/shared/newProject';
import { useClientPortalProjectDataContext } from '../../context/ClientPortalContext';
import { useState } from 'react';

const ApproveClientUsersDrawer = () => {
  const { id, requestId } = useParams();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const { getProjectClientPortalUrl } = useNewProjectUrl();
  const { approveClientUsers, rejectClientUsers, getRejectUserValidation } = useClientPortalService();
  const { isAccessGranted } = useProjectSecurityContext();
  const { clientPortalData, refetchClientPortalContext, isActiveRequestsLoading } = useClientPortalProjectDataContext();

  const activeRequests = clientPortalData.clientPortalRedmineRequests || [];
  const activeRequest = activeRequests.find(request => request.id === requestId);
  const canReviewClientPortal = isAccessGranted(ACCESS_INFO_SECTIONS.CLIENT_PORTAL, ACCESS_INFO_ACTIONS.REVIEW);
  const handleClose = () => {
    setOpen(false);
  };

  const approveUsers = async (values: FormFieldsData) => {
    return await approveClientUsers(id!, requestId!, { decisionNote: values.decisionNote });
  };

  const rejectUsers = async (values: FormFieldsData) => {
    return await rejectClientUsers(id!, requestId!, { decisionNote: values.decisionNote });
  };
  const handleReviewed = () => {
    refetchClientPortalContext();
    handleClose();
  };

  return (
    <SideDrawer
      title="Review client portal access request"
      width={760}
      content={
        canReviewClientPortal ? (
          <ApproveClientUsersDrawerContent
            onReviewed={handleReviewed}
            approveClientUsers={approveUsers}
            rejectClientUsers={rejectUsers}
            getRejectUserValidation={getRejectUserValidation}
            projectData={clientPortalData}
            activeRequest={activeRequest}
            isActiveRequestsLoading={isActiveRequestsLoading}
          />
        ) : null
      }
      isOpen={open}
      onClose={handleClose}
      transitionProps={{
        onExited: () => {
          navigate(getProjectClientPortalUrl(id), { preventScrollReset: true });
        },
      }}
    />
  );
};

export default ApproveClientUsersDrawer;
